import {ReactNode} from 'react';

import {useToggleSidebar} from '@app/contexts/toggleSidebar';

interface Props {
  title: ReactNode;
  titleSuffix?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
}
export function AccountSettingsPanel({
  title,
  titleSuffix,
  children,
  actions,
}: Props) {
const {isdarkMode} = useToggleSidebar();

  return (
    <section className={`bg-paper rounded border px-24 py-20 mb-24 w-full max-w-1140 ${isdarkMode ? "bg-[#202124] text-white" : ""}`}>
      <div className="border-b pb-10 flex items-center gap-14">
        <div className="text-lg font-light">{title}</div>
        {titleSuffix && <div className="ml-auto">{titleSuffix}</div>}
      </div>
      <div className="pt-24">{children}</div>
      {actions && (
        <div className="pt-10 mt-36 border-t flex justify-end">{actions}</div>
      )}
    </section>
  );
}
